import { QueryParameters, QueryParameterSchema, QueryParametersSchema, QueryParametersKey } from './types';

export function createSchema<
  StaticProps,
  SearchQuery,
  Parameters extends QueryParameters,
  Schema extends QueryParametersSchema<StaticProps, SearchQuery, Parameters> = QueryParametersSchema<
    StaticProps,
    SearchQuery,
    Parameters
  >,
>(schema: Schema) {
  const parameters = Object.entries(schema).map(([key, parameter]) => {
    return {
      key: key as keyof QueryParametersSchema<StaticProps, SearchQuery, Parameters>,
      ...(parameter as QueryParameterSchema<StaticProps, SearchQuery, Parameters, typeof key, Parameters[typeof key]>),
    };
  });

  function get<Key extends QueryParametersKey<Parameters>>(key: Key): Schema[Key] {
    return schema[key];
  }

  return {
    get,
    parameters,
    schema,
  };
}

export type SchemaHolder<
  StaticProps,
  SearchQuery,
  Parameters extends QueryParameters,
  Schema extends QueryParametersSchema<StaticProps, SearchQuery, Parameters> = QueryParametersSchema<
    StaticProps,
    SearchQuery,
    Parameters
  >,
> = ReturnType<typeof createSchema<StaticProps, SearchQuery, Parameters, Schema>>;
